
import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AnimalInfo, Animal } from "../../Services";
import { RootState } from "..";


export const activeAnimalDataAdapter = createEntityAdapter({
  selectId: (animal: AnimalInfo) => animal.animal_id
});


export const activeAnimalSlice = createSlice({
  name: "animalsActive",
  initialState: activeAnimalDataAdapter.getInitialState({loading: "idle"}),
  reducers: {
    addActiveAnimals: (state, {payload}: PayloadAction<AnimalInfo[]>) => {
      state.loading = "false";
      activeAnimalDataAdapter.addMany(state, payload);
    },
    updateActiveAnimal: activeAnimalDataAdapter.updateOne,
    updateAllActiveAnimals: activeAnimalDataAdapter.updateMany,
    resetActiveAnimals: activeAnimalDataAdapter.upsertMany,
    clearActiveAnimals: activeAnimalDataAdapter.removeAll,
  },
    
})


export const { addActiveAnimals, resetActiveAnimals, updateActiveAnimal, updateAllActiveAnimals, clearActiveAnimals } = activeAnimalSlice.actions;
export const {selectById: selectActiveAnimalById} = activeAnimalDataAdapter.getSelectors((state: RootState) => state.activeState.activeAnimal);